sn-how-it-works-type-1 {
  display: block;
  margin-bottom: 32px;

  .column {
    display: block;
  }

  .section-side-title {
    font-size: 24px;
    font-weight: 700;
    line-height: 1.33;
    margin: 0 0 24px;
    color: #1a1a1a;

    // Rendered as <me-heading tag="h2"> for SEO: keep the side-title look
    // instead of the global h2 heading sizing/margin.
    h2,
    .me-heading {
      font: inherit;
      color: inherit;
      margin: 0;
    }
  }

  .how-it-works {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  .how-it-works__item {
    display: flex;
    align-items: flex-start;
    gap: 16px;
  }

  .how-it-works__icon {
    flex-shrink: 0;
    width: 64px;
    height: 64px;

    svg {
      display: block;
      width: 100%;
      height: 100%;
    }
  }

  .how-it-works__details,
  .how-it-works__text {
    flex: 1;
    font-size: 16px;
    line-height: 24px;
    color: #4a4a4a;
    padding-top: 4px;

    @include desktop {
      font-size: 20px;
      line-height: 28px;
    }

    strong {
      font-weight: 700;
      color: #1a1a1a;
      margin-right: 4px;
    }

    span {
      margin-left: 0;
    }

    .line-break {
      display: block;
    }
  }
}
